const ADJUSTMENT_FACTOR = 1.15;
const MAX_MULTIPLIER = 1.5;

const createMetricScale = (metricValue: number) => {
  if (metricValue <= 0) {
    return [0, 0, 0, 0, 0];
  }

  const metric = metricValue * ADJUSTMENT_FACTOR;

  const minInterval = metric / 4.0;

  const power = 10 ** Math.floor(Math.log10(minInterval));
  const normalizedInterval = minInterval / power;
  const niceSteps = [1, 1.5, 2, 2.5, 5, 10];

  const niceNormalizedInterval =
    niceSteps.find(step => step >= normalizedInterval) ??
    metricValue * MAX_MULTIPLIER;

  const finalInterval = niceNormalizedInterval * power;
  return Array.from({ length: 5 }, (_, i) => {
    const val = finalInterval * i;
    return parseFloat(val.toPrecision(14));
  });
};

export default createMetricScale;
